// Fable-authored wording shared by the event and tournament form editors.
export const FORM_COPY = {
  nav: {
    tileLabel: 'Forms',
    tileDescription: 'Sign-up forms and responses for events and tournaments',
    pageTitle: 'Forms',
    tabEvents: 'Events',
    tabTournaments: 'Tournaments',
  },
  registrationStatus: {
    notOpen: 'Hidden from members',
    open: 'Registration open',
    closed: 'Registration closed',
    archived: 'Archived',
  },
  formStatus: {
    notOpen: 'Hidden from teams',
    open: 'Form open',
    closed: 'Form closed',
  },
  actions: {
    save: 'Save',
    preview: 'Preview',
    openRegistration: 'Open registration',
    closeRegistration: 'Close registration',
    archiveEvent: 'Archive event',
    openForm: 'Open form',
    closeForm: 'Close form',
    duplicateForm: 'Duplicate form',
  },
  disabledReasons: {
    nothingToSave: 'Everything is saved.',
    saveFirst: 'Save your changes first.',
    addQuestionFirst: 'Add a question first.',
  },
  liveNote: 'Members see your changes as soon as you save.',
  toasts: {
    saved: 'Saved.',
    formOpened: 'Form opened.',
    formClosed: 'Form closed.',
  },
  openFormModal: {
    title: 'Open form?',
    message: (tournament: string) =>
      `Teams in ${tournament} will see the form and can start submitting responses.`,
    confirm: 'Open form',
  },
  tournament: {
    loading: 'Loading forms…',
    switchTitle: 'Switch form?',
    switchConfirm: 'Switch form',
    refreshTitle: 'Refresh form?',
    refreshConfirm: 'Refresh saved form',
    titleMissing: 'Add a form title.',
    titleLabel: 'Form title',
    saveFailed: 'We couldn’t save your form. Try again.',
    duplicateTitle: 'Duplicate form',
    duplicateEmpty: (kind: string) => `No ${kind}s without a form.`,
    closeTitle: 'Close form?',
    teamHeading: 'Team form',
    teamLoading: 'Loading team form…',
  },
} as const;
